import React, { useState, useEffect } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { getWorkflows } from "../../services/workflowApi";
import { DataState } from "../../context/DataProvider";
// import TriggerForm from "../form/TriggerForm"
import AiWorkflowForm from "./AiWorkflowForm";
import WorkflowCanvas from "./WorkflowCanvas";
import WorkflowExecutionWindow from "../workflowExecution/WorkflowExecutionWindow";
import ToggleButton from "./ToggleButton"; // Import the new ToggleButton

const WorkflowList = () => {
  // const [workflows, setWorkflows] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const { userGoogleId, workflows, setWorkflows } = DataState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [executionWindowOpen, setExecutionWindowOpen] = useState(false);
  const [selectedWorkflowId, setSelectedWorkflowId] = useState(null);

  // Fetch workflows from the backend
  // useEffect(() => {
  //   async function fetchWorkflows() {
  //     const data = await getWorkflows(userGoogleId); // Update the endpoint as needed
  //     //   const data = await response.json();
  //     setWorkflows(data);
  //   }
  //   fetchWorkflows();
  // }, []);

  const toggleDropdown = (workflowId) => {
    setDropdownOpen((prev) => (prev === workflowId ? null : workflowId));
  };
  const handleEditWorkflow = (workflowId) => {
    setSelectedWorkflowId(workflowId);
    setEditModalOpen(true);
  };
  const handleExecutionWindowClick = (workflowId) => {
    setSelectedWorkflowId(workflowId);
    setExecutionWindowOpen(true);
  }
  const closeEditModal = () => {
    setEditModalOpen(false);
    setSelectedWorkflowId(null);
  };
  const closeExecutionWindow = () => {
    setExecutionWindowOpen(false);
    setSelectedWorkflowId(null);
  };

    // Callback function to update the workflow list after a toggle
  const handleWorkflowUpdate = (workflowId, newDisabledState) => {
    setWorkflows((prevWorkflows) =>
      prevWorkflows.map((wf) =>
        wf.id === workflowId ? { ...wf, disabled: newDisabledState } : wf
      )
    );
  };


  return (
    <div className="w-full mt-4">
      <div className="mt-5 flex flex-col gap-5 max-h-[calc(100vh-200px)] overflow-y-auto">
        {workflows.length > 0 ? (
          workflows.map((workflow) => (
            <div
              key={workflow.id}
              className="flex flex-col gap-2 relative py-3 px-4 rounded-md border br-2 bg-2 transition-colors duration-150 ease-in-out text-p-text"
            >
              <div className="flex items-center gap-2">
                {workflow?.apps_expanded?.map((i, index) => (
                  <div
                    key={index}
                    className="flex flex-shrink-0 rounded items-center justify-center w-5 h-5 p-0.5 bg-white"
                  >
                    <img src={i.image} alt="Trigger icon" />
                  </div>
                ))}
                <strong className="flex-1 truncate text-md font-medium">
                  {workflow.title || "Untitled"}
                </strong>
                 {/* MODIFICATION: Added ToggleButton and adjusted layout */}
                <div className="flex items-center gap-4 relative z-10 ml-auto">
                  <ToggleButton
                    workflow={workflow}
                    onUpdate={handleWorkflowUpdate}
                  />
                  <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                      <button
                        type="button"
                        onClick={() => toggleDropdown(workflow.id)}
                        className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed -mr-1 py-1 px-1 border-0 bg-transparent flex items-center text-p-text"
                      >
                        <span className="sr-only">Open workflow options</span>
                        <PiDotsThreeOutlineVerticalFill className="text-xl" />
                      </button>
                    </DropdownMenu.Trigger>
                    <DropdownMenu.Portal>
                      <DropdownMenu.Content
                        className="DropdownMenuContent text-zinc-200 bg-zinc-900 shadow-lg p-2 border border-zinc-700 rounded-lg overflow-hidden z-20"
                        sideOffset={8}
                      >
                        {[
                          // { label: "Workflow Graph", onClick: () => { } },
                          // { label: "Execution Window", onClick: () => {  } },
                          { label: "Execution Window", onClick: () => { handleExecutionWindowClick(workflow.id); } },
                          { label: "Edit Workflow", onClick: () => { handleEditWorkflow(workflow.id); } },
                          { label: "Delete Workflow", onClick: () => { } },
                        ].map((option, index) => (
                          <DropdownMenu.Item key={index}>
                            <button
                              onClick={option.onClick}
                              className="block px-5 py-2 text-sm w-full text-left bg-1-hover hover:bg-zinc-800 focus:bg-gray-700 rounded-md transition-all duration-150"
                            >
                              {option.label}
                            </button>
                          </DropdownMenu.Item>
                        ))}
                      </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                  </DropdownMenu.Root>
                </div>
              </div>
              <p className="text-sm font-normal text-s-text border br-1 bg-1 px-3 py-2 rounded-xl mt-2">
                {workflow.description || "No Description"}
              </p>
            </div>
          ))
        ) : (
          <div className="flex flex-col gap-4 sm:gap-5 items-center justify-center h-64 sm:h-96 bg-2 rounded-lg p-3 sm:p-4 border br-1 text-center">
            <span className="text-s-text text-sm sm:text-base">
              No workflows available
            </span>
            <span className="text-p-text text-lg sm:text-xl max-sm:w-[80%] font-semibold">
              Create your first workflow to get started
            </span>
          </div>
        )}
      </div>
      {/* Render WorkflowCanvas in a modal for editing */}
      {editModalOpen && (
        <div className="fixed inset-0 z-999 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded shadow-lg w-4/5 h-4/5">
            <WorkflowCanvas
              closeModal={closeEditModal}
              mode="edit"
              workflowId={selectedWorkflowId}
            />
          </div>
        </div>
      )}
      {executionWindowOpen && (
        <div className="fixed inset-0 z-999 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded shadow-lg w-4/5 h-4/5">
            <WorkflowExecutionWindow
              closeModal={closeExecutionWindow}
              // mode="edit"
              workflowId={selectedWorkflowId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowList;